import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
import AlertType from '../utils/alertType'

Vue.use(VueAxios, axios);

//Vue.axios.defaults.baseURL = "https://localhost:44375/api";
Vue.axios.defaults.baseURL = "https://januario.meiratech.com.br/api/";

Vue.axios.interceptors.request.use((config) => {
    store.commit("overlay/toggleOverlay", true);
    var token = store.getters["auth/token"];
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    config.headers.common['Access-Control-Allow-Origin'] = '*'
    if (!config.headers['Content-type'])
        config.headers['Content-type'] = 'application/json';
    store.commit("overlay/toggleOverlay");
    return config
}, (error) => {
    store.commit("overlay/toggleOverlay", false);
    return Promise.reject(error)
}
);

Vue.axios.interceptors.response.use((response) => {
    store.commit("overlay/toggleOverlay", false);    
    if (response.status === 200 || response.status === 201) {
        if (response && response.data) {
            let resp = response.data;
            if (resp instanceof Blob) {
                return resp;
            }
            if (resp.messages && resp.messages.length) {
                store.commit("dialog/setAlertMessage", { messages: resp.messages, alert: AlertType.SUCESSO });
            }
            if (!resp.success) {
                return Promise.reject();
            } else {
                return resp;
            }
        }
        return response.data || response;
    }
    return response
}, (error) => {
    store.commit("overlay/toggleOverlay", false);
    if (error.response && error.response.status == 401) {
        store.commit("auth/logout");
        window.location.reload();
    } else if (error.response.status == 415) {
        store.commit("dialog/setServerError", "Erro ao enviar as informações");
    } else {
        try {
            let respData = error.response.data;
            if (respData instanceof Blob) {
                if (respData.type === "application/json") {
                    var fr = new FileReader();
                    fr.onload = function () {
                        store.commit("alert/showAlert", JSON.parse(this.result).errors);                        
                    };
                    fr.readAsText(respData);
                }
                else
                    throw new Error("Erro ao enviar as informações");
            } else {

                if (typeof (respData) === "string") {
                    store.commit("dialog/setServerError", "Erro ao enviar as informações");
                } else {
                    store.commit("alert/showAlert", respData.errors);
                    //return Promise.reject(respData.errors);
                }
            }
        } catch (error) {
            store.commit("dialog/setServerError", "Erro ao enviar as informações");
        }
    }

    return Promise.reject();
})